<template>
  <div class="step2-container">
    <div class="step2-content">
      <h2 class="step2-title">
        <span class="step2-title-bold">고객님의 이름</span>을<br>
        입력해주세요.
      </h2>
      
      <div class="step2-input-button-container">
        <button class="step2-button step2-button-prev" @click="$emit('close')">이전</button>
        <div class="step2-input-wrapper">
          <input 
            type="text" 
            inputmode="text" 
            class="step2-input" 
            placeholder="한글로 이름을 입력하세요"
            v-model.trim="cname"
            maxlength="10"
            @input="onInput"
            >
          <p class="step2-info">
            정보 입력 후 접수 신청 시 개인정보 활용에 동의한 것으로 간주됩니다.
          </p>
        </div>
        <button 
          class="step2-button step2-button-next" 
          @click="onClickNext"
          :disabled="!isNextButtonEnabled"
          :class="{ 'step2-button-disabled': !isNextButtonEnabled }"
        > 다음
        </button>
      </div>

      <div class="step2-event">
        <img class="step2-event-image" src="/static/salesReservation/coffee.png" alt="커피 이미지">
        <div class="step2-event-content">
          <h3 class="step2-event-title">커피 무료 증정 EVENT</h3>
          <p class="step2-event-description">
            보험 상담을 신청하고<br>
            무료로 커피를 받아가세요!
          </p>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="showInputCsn">
      <inputCsn 
        v-bind="{ pn, refin, sorce, me, cname }"
        @close="showInputCsn = false"
        @resetValue="resetValue"
      />
        
    </div>
  </div>
</template>


<script>
import inputCsn from './Step3.vue'

export default {
  components: {
    inputCsn
  },
  props: {
    refin: { type: String, default: '' },
    sorce: { type: String, default: '' },
    pn: { type: String, default: '' },
    me: { type: String, default: '' },
  },
  emits: ['resetValue'],
  computed: {
    isNextButtonEnabled() {
      return this.cname.length >= 2;
    }
  },
  data() {
    return {
      cname: '',
      showInputCsn: false
    }
  },
  methods: {
    onInput(event) {
      this.validateAndUpdateInput(event.target.value);
    },
    validateAndUpdateInput(value) {
      const koreanRegex = /^[ㄱ-ㅎ가-힣]*$/;
      if (koreanRegex.test(value)) {
        this.cname = value.trim();
      } else {
        this.cname = value.replace(/[^\ㄱ-ㅎ가-힣]/g, '').trim();
      }
    },
    resetValue() {
      debugger
      this.cname = '';
      this.showInputCsn = false;
      console.log('emit으로 리셋 step2');
      this.$emit('resetValue')
    },
    onClickNext(){
      this.cname
      this.showInputCsn = true
    }
  },
}
</script>
<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.css");

:root {
  --font-pretendard: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}

body {
  font-family: var(--font-pretendard);
}

.step2-container {
  background: #ffffff;
  width: 1194px;
  height: 834px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 40px;
  box-sizing: border-box;
}

.step2-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.step2-title {
  color: #000000;
  text-align: left;
  font-family: var(--font-pretendard);
  font-size: 44px;
  line-height: 150%;
  letter-spacing: 0.03em;
  font-weight: 400;
  margin-bottom: 100px;
  align-self: flex-start;
  padding-left: 15px; 
}

.step2-title-bold {
  font-weight: 600;
}

.step2-input-button-container {
  display: flex;
  justify-content: center;
  align-items: flex-start; /* 상단 정렬로 변경 */
  width: 100%;
  margin-bottom: 40px;
}

.step2-input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
}

.step2-input {
  background: #ffffff;
  border-radius: 36px;
  border: 3.5px solid #184de5;
  width: 540px;
  height: 80px; 
  font-size: 24px;
  padding: 0 20px;
  text-align: center;
  margin-bottom: 10px; 
  margin-left: 50px;
  margin-right: 50px;
}

.step2-button {
  border-radius: 50px;
  width: 200px;
  height: 80px; 
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: var(--font-pretendard);
  font-size: 26px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.step2-button-prev {
  background: var(--grays-gray-3, #c7c7cc);
}

.step2-button-next {
  background: #184de5;
}
.step2-button-disabled {
  background: #c7c7cc;
  cursor: not-allowed;
}

.step2-info {
  color: var(--grays-gray, #8e8e93);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  margin: 0;
  padding: 0;
}

.step2-event {
  background: rgba(24, 77, 229, 0.05);
  border-radius: 20px;
  width: 380px;
  height: 148px;
  position: absolute;
  left: 60px; /* 왼쪽 위치 조정 */
  bottom: 111px;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.step2-event-image {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  margin-right: 20px;
}

.step2-event-content {
  display: flex;
  flex-direction: column;
}

.step2-event-title {
  color: #000000;
  font-family: var(--font-pretendard);
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 10px;
}

.step2-event-description {
  color: #000000;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
}

.overlay {
  position: absolute; /* fixed에서 absolute로 변경 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>